import { useEffect, useState } from "react";
import Api from "../../Api";
import { ListUsers } from "../../component";

const Users = () => {
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [listCount, setListCount] = useState(0);

  interface UserType {
    userId: number;
    fullName: string;
    email: string;
    mobile: string;
    state: string;
  }
  const initialState = {
    stateId: 0,
    fullName: "",
    email: "",
    mobile: "",
    state: "",
  };

  interface StateType {
    stateName: string, 
    stateId: string}
   
  const [findOptions, setFindOptions] = useState(initialState);
  const [users, setUsers] = useState<UserType[]>([]);
  const [stateOptions, setStateOptions]=useState<StateType[]>([])

  const api = Api();

  const fetchUser = async (findOptions: any) => {
    const response = await api.user.fetchUser(findOptions);
    if(response){
      setListCount(response.usersListCount);
      setUsers(response.usersList);
      if(response.usersListPageIndex>1 && response.usersListPageSize === 0){
        setPageIndex(pageIndex-1)
      }
    }
  };

  const handleFindUser = (findOptions: any) => setFindOptions(findOptions);

  const onChangePageIndex = (pageNumber: number) =>
    setPageIndex(pageNumber - 1);
  const onChangePageSize = (pageSize: number) => setPageSize(pageSize);
  const resetFindOptions = () => setFindOptions(initialState);

  const fetchStateForDropdown = async () => {
    const response = await api.state.getStates();
    setStateOptions([...response.states])

  };

  useEffect(() => {
    fetchUser({...findOptions, pageIndex, pageSize});
  }, [findOptions, pageIndex, pageSize]);

  useEffect(()=>{
    fetchStateForDropdown()
  },[])

  return (
    <div className="w-100 p-2">
      <ListUsers
        usersList={users}
        totalItemCount={listCount}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onChangePageIndex={(pageNumber: number) =>
          onChangePageIndex(pageNumber)
        }
        onChangePageSize={onChangePageSize}
        findOptions={findOptions}
        resetFindOptions={resetFindOptions}
        handleFindUser={handleFindUser}
        stateListForDropdown={stateOptions}
      />
    </div>
  );
};

export default Users;
